import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/skeleton/index.tsx';
import { matchUrlPathname } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import { getNextgenSettingsUrl } from '@atlassian/jira-project-settings-apps-common/src/urls.tsx';
import { useIssueTypesNavigationItems as useIssueTypesNavigationItemsNext } from '@atlassian/jira-spa-apps-project-settings-issue-type/src/controllers/issue-types-navigation-items/index.tsx';

import { AddRequestTypeDropdown } from './add-request-type-dropdown/index.tsx';

export const IssueTypes = () => {
	const [issueTypesData] = useIssueTypesNavigationItemsNext();
	const navigationItems = [
		...issueTypesData.baseLevel,
		...issueTypesData.bottomLevel,
		...issueTypesData.topLevel,
	];
	const { data: project } = useProject();

	const { isAddIssueTypeDisabled } = issueTypesData;

	if (!project || !navigationItems.length) return <Skeleton />;

	const baseSettingsUrl = getNextgenSettingsUrl(SERVICE_DESK_PROJECT, project.key);

	return (
		<>
			{navigationItems.map((issueType) => (
				<MenuItem
					key={String(issueType.id)}
					analytics={{ itemId: String(issueType.id) }}
					selectedOn={matchUrlPathname()}
					href={`${baseSettingsUrl}/issuetypes/${issueType.id}`}
				>
					{issueType.name}
				</MenuItem>
			))}
			{issueTypesData.addIssueTypeTooltip ? (
				<Tooltip content={issueTypesData.addIssueTypeTooltip}>
					<AddRequestTypeDropdown isDisabled={isAddIssueTypeDisabled} projectId={project.id} />
				</Tooltip>
			) : (
				<AddRequestTypeDropdown isDisabled={isAddIssueTypeDisabled} projectId={project.id} />
			)}
		</>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SpotlightedItems = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.selected'),
});
